import { useEffect, useState } from 'react';
import { loadVisitorStats, type VisitorStats } from '../../../lib/visitorStats';

export default function VisitorsPanel() {
  const [stats, setStats] = useState<VisitorStats | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  async function refresh() {
    setLoading(true);
    const result = await loadVisitorStats();
    setStats(result.stats);
    setError(result.error || '');
    setLoading(false);
  }

  useEffect(() => { void refresh(); }, []);

  return (
    <div className="space-y-6">
      <section className="rounded-3xl border border-white/10 bg-white/5 p-5 sm:p-6">
        <div className="flex items-center justify-between mb-6"><div><h2 className="font-bold text-xl">زوار الموقع</h2><p className="text-sm text-gray-400 mt-1">أرقام بسيطة فقط، بدون أسماء أو معلومات شخصية.</p></div><button onClick={refresh} className="rounded-xl border border-white/10 px-4 py-2 text-sm">تحديث</button></div>
        {loading ? <div className="py-10 text-center text-gray-500">جاري التحميل...</div> : stats ? <div className="grid sm:grid-cols-3 gap-4">
          <StatCard label="زوار اليوم" value={stats.today} icon="ri-calendar-check-line" />
          <StatCard label="زوار هذا الشهر" value={stats.month} icon="ri-calendar-2-line" />
          <StatCard label="العدد الكلي" value={stats.total} icon="ri-group-line" />
        </div> : <div className="rounded-2xl border border-[#F5A623]/20 bg-[#F5A623]/5 p-5"><p className="font-bold text-[#F5A623]">عداد الزوار يحتاج تفعيل مرة واحدة</p><p className="text-sm text-gray-300 leading-7 mt-2">داخل النسخة موجود ملف <span dir="ltr">supabase/admin_studio_setup.sql</span>. من ننفذه على Supabase، هذي الأرقام تشتغل تلقائياً.</p>{error && <p className="text-xs text-gray-500 mt-3" dir="ltr">{error}</p>}</div>}
      </section>
    </div>
  );
}

function StatCard({ label, value, icon }: { label: string; value: number; icon: string }) {
  return <div className="rounded-2xl border border-white/10 bg-black/20 p-5"><div className="w-11 h-11 rounded-xl bg-[#F5A623]/15 text-[#F5A623] grid place-items-center mb-4"><i className={`${icon} text-xl`} /></div><p className="text-sm text-gray-400">{label}</p><p className="text-3xl font-black mt-2">{value.toLocaleString('ar-IQ')}</p></div>;
}
